export const COURSE_LINK = 'https://rs.school/js/'
export const FOOTER_HEIGHT = '30px'
